import React, { FC } from "react";
import { FlyoutLink } from "@app/shared/Flyouts";
import ProviderActionsDrawer from "@app/projects/network-assessment/provider-actions/ProviderActionsDrawer";

interface ProviderActionsDrawerFlyoutProps {
  classNames?: string;
  disabled?: boolean;
  testId: string;
  resetBanner?: (hasUnprocessedTerminations: boolean, hasUnprocessedTargets: boolean, hasUnprocessedExcludes?: boolean) => Promise<void>;
}

const ProviderActionsDrawerFlyout: FC<React.PropsWithChildren<ProviderActionsDrawerFlyoutProps>> = (props: React.PropsWithChildren<ProviderActionsDrawerFlyoutProps>) => (
  <FlyoutLink
    asDrawer={true}
    content={{
      body: <ProviderActionsDrawer resetBanner={props.resetBanner}/>,
      title: "Provider Action Management",
    }}
    classNames={props.classNames}
    size="90"
    disabled={props.disabled}
    testId={props.testId}
  >
    {props.children}
  </FlyoutLink>
);

export default ProviderActionsDrawerFlyout;
